const buildAuthorizationHeader = (token: string) => `Bearer ${token}`;

const getTokenFromHeader = (header: string) => header.split(' ')[1];

export { buildAuthorizationHeader, getTokenFromHeader };
